<template>
  <div class="filter">
    <div class="row align-center" id="filterWrapper">
      <div class="small-11 medium-9 large-4 columns">
        <BorderlessSearchBox
          @click-outside="closeFaculdadesCombo"
          :defaultmsg="$t('faculdade')"
          @update:openCombo="switchOption(0)"
          @update:closeCombo="setFaculdade"
          :isOpen="openFaculdade"
          :options="faculdades"
          v-model="faculdade" />
      </div>
      <div class="small-11 medium-9 large-4 columns">
        <BorderlessSearchBox
          @click-outside="closeCursosCombo"
          :defaultmsg="$t('curso')"
          @update:openCombo="switchOption(1)"
          @update:closeCombo="setCursos"
          :isOpen="openCurso"
          :options="filteredCursos"
          v-model="curso" />
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api.js"; 
import ComboBox from "@/components/ComboBox.vue";
import { ref, computed } from "vue";
import { useStore } from '@/stores/store.ts';
import BorderlessSearchBox from "@/components/borderlessSearchBox/BorderlessSearchBox.vue";


export default {
  components:{
    ComboBox,
    BorderlessSearchBox
  },
  setup(){
    const store = useStore();

    const cursoid = computed(()=> store.cursoid);
    const faculdadeid = computed(()=> store.faculdadeid);

    const faculdade = ref(null)
    const curso = ref(null);

    const faculdades = ref([]);
    const cursos = ref([]);

    const getCursos = () => {
      api.getCursos('pt')
        .then(data => {
          cursos.value = data;
          if(cursoid != null){
            curso.value = cursos.value.find(el => el.id == cursoid);
          }
        })
        .catch(err => {
          console.log(err)
        });
    }

    getCursos()

    const getFaculdades = () => {
      api.getFaculdades('pt')
      .then(data => {
        faculdades.value = data;
        if(faculdadeid != -1 ){
          faculdade.value = faculdades.value.find(el => el.id == store.faculdadeid);
        }
      })
      .catch(err => {
        console.log(err)
      })
    }

    getFaculdades()
    
    const filteredCursos = computed(() => {
      return cursos.value.filter(c => 
        faculdade.value == null || c.faculdade === faculdade.value.id);
    });

    const openFaculdade = ref(false);
    const openCurso = ref(false);

    const closeFaculdadesCombo = () => {
      openFaculdade.value = false;
      if(faculdade.value == null){
        curso.value = null;
      }
    }

    const setFaculdade = () => {
      closeFaculdadesCombo()
      store.faculdadeid = faculdade.value?.id;
      store.getTestemunhos();
    }

    const setFaculdadeAfterChoosingCurso = () => {
      faculdade.value = faculdades.value.find(el => el.id == curso.value.faculdade);
      store.faculdadeid = faculdade.value.id;
    }

    const closeCursosCombo = () => {
      openCurso.value = false;
      if(curso.value !== null){
        setFaculdadeAfterChoosingCurso()
      }  
    }

    const setCursos = () => {
      closeCursosCombo()
      store.cursoid = curso.value?.ID;
      store.getTestemunhos();
    }

    const switchOption = option => {
      if (option == 0) {
        openCurso.value = false;
        openFaculdade.value = !openFaculdade.value;
      } else {
        openFaculdade.value = false;
        openCurso.value = !openCurso.value;
      }
    }

    return {
      faculdades,
      cursos,
      faculdade,
      curso,
      setFaculdade,
      setCursos,
      openFaculdade,
      openCurso,
      filteredCursos,
      switchOption,
      closeCursosCombo,
      closeFaculdadesCombo
    }

  }
};
</script>

<style scoped>
/*358*/
.filter {
  padding-bottom: 70px;
  margin-top: 50px;
}

#filterWrapper {
  max-width: 100rem;
}

@media (max-width: 1024px) {
  .filter {
    margin-top: 20px;
    padding-bottom: 35px;
  }
}

@media (max-width: 767px) {
  /*791*/
  .filter {
    padding-bottom: 10px;
    margin-top: 20px;
  }
}
</style>